// Sales Planning (54_SalesPlanning.jsx) — the one string it still wrote in English, in the portal's four languages
// (2026-10-21). Everything else on these screens reads `spl.` from i18n.js; the Master order format's headings, which
// the order-format upload and the buyer's form are matched on, are the server's and stay as they are.
const en = {
  pcs: '{{n}} pcs',
};

const ko = {
  pcs: '{{n}} pcs',
};

const vi = {
  pcs: '{{n}} cái',
};

const zh = {
  pcs: '{{n}} 件',
};

// French and Japanese (task #1173, 2026-11-04) — generated from `en`; a string not yet translated reads English.
const fr = {
  "pcs": "{{n}} pcs"
};
const ja = {
  "pcs": "{{n}} pcs"
};

const dictionary = { ns: 'xSpl', en, ko, vi, zh, fr, ja };

export default dictionary;
